import { Icon } from '../../layouts'

export default function Close() {
    return (
        <Icon>
            <path d="M1,1 9,9 M9,1 1,9" />
        </Icon>
    )
}
